<app-header></app-header>
<div class="content">
	<div>
		<form
			id="workForm"
			name="registrationForm"
			[formGroup]="passwordRecoveryForm"
			enctype="application/x-www-form-urlencoded"
		>
			<section
				class="form"
				style="min-height: 600px"
			>
				<h2 style="border: none !important">{{ "password.recovery.recovery" | translate }}</h2>
				<div class="d-sm-table-row">
					<div class="col-sm-12 text-center">
						<span class="vehicle-details-field">
							<b>
								{{ "password.recovery.message" | translate }}
							</b>
						</span>
					</div>
				</div>
				<fieldset class="row">
					<div class="d-sm-table-row">
						<div class="field col-sm-6">
							<label for="value">{{ "password.recovery.username" | translate }}</label>
							<input
								id="value"
								required
								type="text"
								name="value"
								formControlName="username"
								maxlength="50"
								placeholder="{{ 'password.recovery.username' | translate }}"
								(ngModelChange)="changeUsername()"
							/>
						</div>
						<div class="field col-sm-6">
							<label for="value2">{{ "password.recovery.email" | translate }}</label>
							<input
								id="value2"
								required
								type="text"
								name="value2"
								formControlName="email"
								maxlength="150"
								placeholder="{{ 'password.recovery.email' | translate }}"
								(ngModelChange)="changeEmail()"
							/>
						</div>
					</div>
					<div class="d-sm-table-row">
						<div class="col-sm-12 text-center">
							<span id="step1_inserisci_fieldsContainer">
								<a
									[class.disabled]="passwordRecoveryForm.invalid || isInValid()"
									(click)="onSubmit()"
									class="btn btn-red button--big"
									style="color: #fff"
								>
									{{ "password.recovery.recover" | translate }}
								</a>
							</span>
						</div>
					</div>
				</fieldset>
			</section>
		</form>
	</div>
</div>